import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";
import { BiError } from "react-icons/bi";
import { BlinkLoader } from "../components/loader";
import { setCookie } from "../config/webStorage.js";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loginloading, setloginloading] = useState(false);
  const navigate = useNavigate();

  const loginHandler = async (e) => {
    e.preventDefault();
    if (!email) return setError("Please enter email address");
    try {
      setloginloading(true);
      const response = await axios.post(`${apiurl}/admin/v1/user/login`, {
        email,
      });
      if (!response.data.success) {
        setError(response.data.message);
      } else {
        const loginToken = response.data.token;
        setCookie("sctoken", loginToken, 50 * 60);
        navigate("/dashboard");
      }
    } catch (error) {
      setError("Login failed. Please try again.");
    } finally {
      setloginloading(false);
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  console.log("isChecked",isChecked);
  return (
    <>
      <div className="w-[100vw] min-h-screen flex justify-center align-middle items-center p-2 md:p-10">

        <div className="w-full h-full xl:max-h-[600px] md:w-[90%] xl:w-[70%] md:h-[80%] mx-auto border border-slate-300 rounded-xl md:shadow-md">
          <div className="rounded-lg  md:w-[100%] mx-auto  md:h-screen-xl w-full h-full flex flex-col md:flex-row">
            {/* <img
            src={logo}
            alt="Logo"
            className="h-16 md:hidden mx-auto mb-6 mt-10"
          /> */}

            {/* Left Side */}
            {/* <div className="w-full md:w-1/2 bg-indigo-50 p-8 md:flex flex-col justify-center items-center hidden ">
            <div className=" w-full flex flex-col justify-between h-full relative">
              <div className="flex  justify-center w-full">
                <img src={logo} alt="Logo" className="h-28 mb-6 " />
              </div>
              <div className="flex flex-col  justify-end pb-10 items-start h-full">
                <p className="text-5xl   font-semibold  text-left pr-10 text-gray-600 mb-8">
                  Building the future of digital experiences
                </p>
                <Link
                  to="https:/fixlabs.ai/signup"
                  className="block mt-5  text-center bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 text-xl rounded-md transition duration-200"
                >
                  Sign up
                </Link>
              </div>
            </div>
          </div> */}


            <div className="w-full md:w-1/2 h-auto  md:flex flex-col  justify-center pr-[5%] items-center hidden">
              <div className=" flex flex-col justify-between h-full relative w-[100%]  rounded-xl"
                style={{
                  background: 'linear-gradient(156.97deg, #9089FF 14.91%, #CECBFF 58.52%, #FFFFFF 93.18%)',
                }}>

                <div className="flex flex-col w-full  justify-start align-middle items-center mt-5 h-full">
                  <p className="md:text-2xl lg:text-4xl xl:text-5xl text-white font-thin mx-auto">INFICONNECT</p>

                  {/* <Link
                to="https:/fixlabs.ai/signup"
                className="block mt-5  text-center bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 text-xl rounded-md transition duration-200"
              >
                Sign up
              </Link> */}
                </div>
                <div className="flex absolute bottom-0 -right-[20%] justify-center w-auto h-[80%]">
                  <img src="/forgotpasswordBackground.png" alt="Logo" className=" " />
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="w-full md:w-1/2 h-full flex flex-col justify-center pl-10 items-center p-5">
              <div className="max-w-md w-full">
                <div className="flex  justify-center w-full">
                  <img src="/logo.png" alt="Logo" className="h-10 mb-6 " />
                </div>
                <h2 className="text-xl md:text-2xl font-semibold text-center text-gray-800 mb-2">
                  Forget your account password
                </h2>
                <p className="text-gray-500 text-center mb-8">
                  Please enter your email address
                </p>

                <form onSubmit={loginHandler} className="space-y-4">
                  <div>
                    <input
                      type="email"
                      placeholder="Email"
                      className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError("");
                      }}
                    />
                  </div>

                  {error && (
                    <div className="text-red-500 text-sm flex items-center gap-2">
                      <BiError /> {error}
                    </div>
                  )}

                  <div className="flex items-center justify-between">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                      />
                      <span className="ml-2 text-sm text-gray-600">
                        I accept the{" "}
                        <Link className="text-indigo-600 hover:underline" to="/">
                          {" "}
                          Terms and Conditions
                        </Link>
                      </span>
                    </label>
                  </div>


                  <button
                    type="submit"
                    className={`w-full ${loginloading || !isChecked ? "bg-indigo-400" : "bg-indigo-600"}  hover:bg-indigo-700 h-11 relative text-white py-5 rounded-md transition duration-200 flex items-center justify-center`}
                    disabled={loginloading || !isChecked}
                  >
                    {loginloading ? <BlinkLoader /> : "Reset Password"}
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <p className="text-sm text-gray-600">
                    Don't have an account yet?{" "}
                    <Link
                      to="https://fixall.ai/products/sales/inficonnect/signup"
                      className="text-indigo-600 hover:text-indigo-500"
                    >
                      Sign up
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;